<template>
  <div class="card mt-2">
    <div class="card-header py-2">
      <button type="button" class="close" aria-label="Close" @click="$emit('regresar')">
        <span aria-hidden="true">&times;</span>
      </button>
      Productos Agregados
    </div>
    <div class="card-body pt-2 mb-3">
      <div v-if="cargando">
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <p class="text-center mt-3">Espere mientras se carga el detalle de la compra</p>
      </div>
      <div v-else>
        <div v-if="lista.length > 0">
          <div class="row mb-2" v-if="actual == 1">
            <div class="col-md-8">
              <h4>TOTAL Q {{ totalFormato }} </h4>
            </div>
            <div class="col-md-4 text-right">
              <button 
                class="btn btn-primary float-right px-4" 
                type="button"
                @click="actual = 2"
                v-if="!confirmado"
              >
                <i class="fas fa-check-circle mr-2"></i>Confirmar compra
              </button>
            </div>
          </div>
          <div class="row">
            <div v-if="actual == 1" class="col-md-12">
                <ul class="list-group">
                    <li class="list-group-item" v-for="(item, index) in lista" :key="index">
                        <div class="row">
                            <div class="col-md-2">
                                <img :src="item.imagen" class="card-img" :alt="item.nombre">
                            </div>
                            <div class="col-md-6">
                                <h5>{{ item.nombre }}</h5>
                                <div v-if="item.presentacion_seleccionada !== ''">
                                    {{ item.cantidad }} 
                                    {{ item.presentacion_seleccionada.nombre }}
                                </div>
                                <small>{{ item.descripcion }}</small>
                                <textarea class="form-control" v-model="item.nota" placeholder="Agregue una nota. (Opcional)" rows="1"></textarea>
                            </div>
                            <div class="col-md-2">
                                <p>
                                    Q {{ item.presentacion_seleccionada == '' ? item.precio : item.presentacion_seleccionada.precio }} X {{ item.cantidad }}
                                </p>
                                <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                                    <div class="btn-group btn-group-sm mr-2" role="group" aria-label="First group">
                                        <button 
                                            type="button" 
                                            class="btn btn-danger" 
                                            title="Quitar del carro"
                                            @click="quitarProducto(index)">X</button>
                                    </div>
                                    <div class="btn-group btn-group-sm mr-2" role="group" aria-label="Second group">
                                        <button 
                                            type="button" 
                                            class="btn btn-secondary" 
                                            title="Restar una unidad"
                                            :disabled="item.cantidad <= 1"
                                            @click="actualizarProducto(index, false)">-</button>
                                        <button 
                                            type="button" 
                                            class="btn btn-secondary"
                                            title="Agregar una unidad" 
                                            @click="actualizarProducto(index, true)">+</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <h5>Subtotal</h5>
                                <p>Q {{ item.presentacion_seleccionada == '' ? (item.precio * item.cantidad) : (item.cantidad * item.presentacion_seleccionada.precio ) }}</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
          </div>
          <div class="row" v-if="actual == 2" >
            <div class="offset-md-3 col-md-6">
              <BazarConfirmar 
                :emp="emp"
                :detalle="lista"
                :total="totalPago"
                :formato="totalFormato"
                @regresar="actual = 1"
                @actSaldo="actualizaSaldo"
                @actTotal="actualizaItems"
                @actualizar="confirmado = true"/>
            </div>
          </div>
        </div>
        <div v-else class="text-center">No hay detalle de compra.</div>
      </div>
    </div>
  </div>
</template>

<script>
  import BazarConfirmar from './BazarConfirmar.vue';
  import axios from 'axios';

  export default {
    name: 'BazarCarro',
    props: {
      emp: {
        type: Object,
        required: true
      }
    },
    data:() => ({
      lista: [],
      confirmado: false,
      cargando: false,
      header: null,
      actual: 1
    }),
    created () {
      this.getCompra();
    },
    methods: {
      getCompra() {
        this.cargando = true;
        this.header = JSON.parse(localStorage.getItem(`bazar_${this.emp.dominio}`))

        axios.defaults.headers = {
          Authorization: this.header.token
        }

        axios
        .get('/app.php/bazar/get_compra')
        .then(res => {
          if (res.data.exito) {
            this.lista = res.data.lista;
          } else {
            this.lista = [];
          }
          this.cargando = false;
        }).catch(e => {
          this.cargando = false;
          alert('Detalle'+e);
        });
      },
      quitarProducto (index) {
        axios.defaults.headers = {
          Authorization: this.header.token
        }

        let tmp = this.lista[index];

        axios
        .post('/app.php/bazar/quitar_detalle', tmp)
        .then(res => {
          if (res.data.exito) {
            this.lista.splice(index,1);
            this.$emit('actTotal', tmp.cantidad, false);
          } else {
            alert(res.data.mensaje);
          }
        }).catch(e => {
          alert('Quitar detalle'+e);
        });
      },
      actualizarProducto(index, valor) {
        axios.defaults.headers = {
          Authorization: this.header.token
        }

        let tmp = this.lista[index];

        if (valor) {
          tmp.cantidad++;
        } else {
          tmp.cantidad--;
        }

        axios
        .post('/app.php/bazar/actualizar_producto', tmp)
        .then(res => {
          if (res.data.exito) {
            this.$emit('actTotal', 1, valor);
          }
        }).catch(e => {
          alert('Quitar detalle'+e);
        });
      },
      actualizaSaldo(valor) {
        this.$emit('actSaldo', valor);
      },
      actualizaItems(valor) {
        this.$emit('actTotal',valor, false);
      }
    },
    computed: {
      totalPago() {
        let total = 0;

        this.lista.forEach(e => {
            if (e.presentacion_seleccionada == '') {
                total += (e.cantidad * e.precio);
            } else {
                total += (e.cantidad * e.presentacion_seleccionada.precio);
            }
        });

        return total;
      },
      totalFormato () {
        return new Intl.NumberFormat("es-GT", {minimumFractionDigits: 2}).format(this.totalPago)
      }
    },
    components: {
      BazarConfirmar
    }
  }
</script>